import { FC } from 'react';

import { GetMoreEnvelopesModal } from '../../events/modals/get-more-envelops-modal';
import { SignaturesTable } from './components/table/signature-table';
import { signatureFormTypeComponentMap } from './constants/signature-form-type-map.constant';
import { signaturePopupTypeComponentMap } from './constants/signature-popup-type-map.constant';
import { SignatureFormStore } from './store/signature-form.store';
import { SignaturePopupStore } from './store/signature-popup.store';

export const DocumentsSignaturesPage: FC = () => {
  const formType = SignatureFormStore(({ type }) => type);
  const popupType = SignaturePopupStore(({ type }) => type);

  return (
    <div className="flex w-full flex-1 flex-col gap-4 lg:py-4 lg:pl-4">
      {signatureFormTypeComponentMap[formType]}
      {signaturePopupTypeComponentMap[popupType]}
      <GetMoreEnvelopesModal />
      <SignaturesTable />
    </div>
  );
};
